import { Box, IconButton } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import CloseIcon from "@mui/icons-material/Close";
import { Alert } from "@mui/material";
import Config from "Config";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import AlertDialog from "../AlertDialog/AlertDialog";
const Notification = ({ fixed = false, edb = false, closedButton = false }) => {
    const stackbar = true;
    const { t, i18n } = useTranslation();
    const [isClosed, setClosed] = useState(false);
    const [notificationData, setNotificationData] = useState(null);
    const [hasNotice, setHasNotice] = useState(false);

    const useStyles = makeStyles(() => ({
        myAlert: {
            width: "100%",
            // flex: 1,
            top: 0,
            left: 0,
            margin: 0,
            padding: 0,
            zIndex: 9999,
            position: fixed ? "sticky" : "relative",
        },
        modal: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        },
    }));

    const classes = useStyles();
    const fetchNotificationSettings = async () => {
        try {
            const response = await fetch(
                `${Config.CONTENT_PATH}/settings/getNotifLoginMsgSettings`
            );
            if (response.status !== 200) {
                setHasNotice(false);
                return;
            }
            const result = await response.json();

            if (result?.code === "0" && result?.data?.status === "active") {
                setNotificationData(result.data);
                setHasNotice(true);
            } else {
                setHasNotice(false);
            }
        } catch (error) {
            setHasNotice(false);
        }
    };
    useEffect(() => {
        fetchNotificationSettings();
    }, []);

    const onClose = () => {
        setClosed(true);
    };

    const getNotificationMessage = () => {
        if (!notificationData) {
            return null;
        }
        let notificationMessage =
            i18n.language === "en"
                ? notificationData.messageEn
                : i18n.language === "tc"
                ? notificationData.messageTc
                : notificationData.messageSc;

        if (notificationMessage === "") {
            return null;
        }

        return (
            <span dangerouslySetInnerHTML={{ __html: notificationMessage }} />
        );
    };

    const action = (
        <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={onClose}
        >
            <CloseIcon fontSize="small" />
        </IconButton>
    );

    const StackAlert = () => {
        return (
            <Box className="notice">
                <Alert
                    severity="warning"
                    action={closedButton ? action : null}
                    className={classes.myAlert}
                    classes={{ icon: classes.alertIcon }}
                >
                    {hasNotice && getNotificationMessage()}
                </Alert>
            </Box>
        );
    };

    return (
        <>
            {hasNotice && !edb && !isClosed && (
                <>
                    {stackbar ? (
                        <StackAlert />
                    ) : (
                        <Box className="notice">
                            <AlertDialog />
                        </Box>
                    )}
                </>
            )}
        </>
    );
};

export default Notification;
